import React, {Fragment} from "react";

import SpinnerDiv from "ui/SpinnerDiv";

import {Globals} from "../DataFunctions/BaseDataFns";

import PassportTable, {xlateBootstrapTableColumns } from "root/Tables/PassportTable";
import {
    customHeaderStyle,
    defaultPaginationOptions,
    defaultTableHeaderStyles,
    defaultTopLeftCellStyle, defaultTopRightCellStyle
} from "root/Tables/BaseTableComponents";
import {LOGIN_USERS, UserTypes} from "root/DataFunctions/Constants";
import IconTooltip from "ui/Tooltip/IconTooltip";
import {ModalUserModes} from "root/Modals/ModalUser/ModalUserConstants";
import {childRouteUrl2, childRouteUrl3, schoolRouteUrl, userRouteUrl} from "root/Tables/TableMyPEPs";
import {Link} from "react-router-dom";

const TableUsers = ({data, loading, role_id, onClick} ) =>
{
    // const { user_type } = useSessionContext() ;

    const hyperlink = ( label, link, tip ) =>
    {
        return <Link to={link}>{label}</Link> ;
    }

    const iconRow = ( row ) =>
    {
        const returnURL = btoa(Globals.BaseURL +'/view_users.php?usertype=' + role_id);

        const userType = +(row.type_id) ;

        const phpFile = userType === UserTypes.LAC ? 'view_child.php' : 'edit_user.php' ;

        if ( userType === UserTypes.LAC )
        {

        }
        const child_url =  childRouteUrl3( row.child_id, { activePage: 'setting' }) ;

        const ids =  userType === UserTypes.LAC ? '?userid='+ row.idusers + '&childid=' + row.child_id : '?userid='+ row.idusers ;

        const deleteUrl = phpFile + ids +'&mode=delete&usertype=' + role_id + '&return=' + returnURL ;
        const editUrl = phpFile + ids +'&mode=edit&usertype=' + role_id + '&return=' + returnURL ;
        const viewUrl = phpFile + ids +'&mode=view&usertype=' + role_id + '&return=' + returnURL ;

        const canDelete = role_id !== UserTypes.LAC ;

        const shouldUseModal = [ UserTypes.DESI_TEACHER, UserTypes.ATTENDANCE_OFFICER, UserTypes.EDUCATIONAL_PSYCHOLOGIST, UserTypes.EWS_OFFICER, UserTypes.IRO, UserTypes.SYSTEM_ADMIN,
                                         UserTypes.CARER, UserTypes.ESW, UserTypes.SOCIAL_WORKER, UserTypes.VIRTUAL_SCHOOL_HEAD,
                                         UserTypes.TEAM_LEAD, UserTypes.LEAD_CAREERS_ADVISOR, UserTypes.PERFORMANCE_AND_DEVELOPMENT, UserTypes.CAREERS_ADVISOR,
                                         UserTypes.EHCP_COORDINATOR].includes(userType) ;

        const userCanLogin = LOGIN_USERS.includes(userType) ;

        return (
            <Fragment>
                { shouldUseModal === false && <Link to={child_url} style={{marginRight: '10px'}}><IconTooltip href={ viewUrl } placement='top' text="View Details" icon="glyphicon-user" color="var(--s360-icon-orange)"/></Link> }
                { ( shouldUseModal === true && userCanLogin === true ) && <IconTooltip onClick={() => onClick( { mode: ModalUserModes.RESET_PASSWORD, user_id: +row.idusers, user_type: userType }) } placement='top' text="Reset Password" icon="glyphicon-comment" color="var(--s360-icon-orange)" style={{marginRight: '10px'}}/> }
                { shouldUseModal === false && <Link to={child_url} style={{marginRight: '10px'}}><IconTooltip href={ editUrl } placement='top' text="Edit User" icon="glyphicon-pencil" color="var(--s360-icon-blue)"/></Link> }
                { shouldUseModal === true && <IconTooltip onClick={() => onClick( { mode: ModalUserModes.EDIT, user_id: +row.idusers, user_type: userType }) } placement='top' text="Edit User" icon="glyphicon-pencil" color="var(--s360-icon-blue)" style={{marginRight: '10px'}}/> }
                { ( shouldUseModal === false && canDelete === true ) && <a href={deleteUrl} style={{marginRight: '10px'}}><IconTooltip href={ deleteUrl } placement='top' text="Delete User" icon="glyphicon-trash" color="var(--s360-icon-red)"/></a> }
                { ( shouldUseModal === true && canDelete === true )  && <IconTooltip onClick={() => onClick( { mode: ModalUserModes.DELETE, user_id: +row.idusers, user_type: userType }) } placement='top' text="Delete User" icon="glyphicon-trash" color="var(--s360-icon-red)" style={{marginRight: '10px'}}/> }
            </Fragment>
        )
    }

    const actionURLFormatter = (cell, row) =>
    {
        return iconRow ( row ) ;
    }

    const pupilFormatter = (cell, row, enumObject, index) =>
    {
        const viewChildURL = childRouteUrl3( row.child_id, { activePage: 'setting' }) ;

        const viewChildText = row.firstname + ' ' + row.surname ;

        return hyperlink ( viewChildText, viewChildURL, 'View Pupil Details') ;
    }

    const plainFormatter = (cell, row, enumObject, index) =>
    {
        const this_user_type = +row.type_id ;
        let viewUrl ;
        const returnURL = btoa('/vschool/users/?usertype=' + role_id);

        if ( this_user_type === UserTypes.LAC )
        {
            viewUrl = childRouteUrl2( row.child_id, { activePage: 'setting', mode: 'view' }) ;
        }
        else
        {
            viewUrl = userRouteUrl ( row.idusers, null, returnURL ) + '&userid='+ row.idusers + '&mode=view';
        }

        const viewChildText = row.firstname + ' ' + row.surname ;

        return hyperlink ( viewChildText, viewUrl, 'View User Details') ;
    }

    const colouredText = (text, color ) =>
    {
        return <span style={{ color: color }}>{text}</span>
    }

    const teacherNameFormatter = (cell, row) =>
    {
        let name = colouredText("NOT ASSIGNED", '#d9534f') ;

        if ( row.teacher_full_name != null )
        {
            name = row.teacher_full_name ;
        }

        return name ;
    }

    const isLoginAllowed = ( type ) =>
    {
        return LOGIN_USERS.includes( type ) ;
    }

    const statusFormatter = ( cell, row ) =>
    {
        if ( isLoginAllowed( +row.type_id) )
        {
            if ( row.password_change_required === null )
            {
                return <IconTooltip placement='top' text="Active" icon="glyphicon-ok" color="var(--s360-icon-green)"/>
            }
            else
            {
                const created_date = row.dmy_date_created === null ? ' ( Created before 2023 )' :  "( Created " + row.dmy_date_created + " )" ;
                const label = "Never Logged In " + created_date;
                return <IconTooltip placement='top' text={label} icon="glyphicon-remove" color="var(--s360-icon-red)"/>
            }
        }
        else
        {
            return '' ;
        }
    }

    const headerStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        idusers: {borderRadius: defaultTopLeftCellStyle, width: "20rem"},
        username: { width: "20rem" },
        typeName: {width: "12vw"},
        school_name: {},
        email: {width: "14vw"},
        telno: {width: "12vw"},
        active: {width: "5vw"},
        actions: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "12rem"}
    });

    const getPupilColumns = () =>
    {
        const columns = [
            {
                dataField: "full_name",
                text: "Pupil Name",
                sort: true,
                headerStyle: headerStyle,
                formatter: pupilFormatter
            },
            {
                dataField: "surname",
                text: "Surname",
            },
            {
                dataField: "firstname",
                text: "Firstname",
            },
            {
                dataField: "teacher_full_name",
                text: "Teacher Name",
                sort: true,
                formatter: teacherNameFormatter,
                headerStyle: headerStyle,
            },
            ...schoolCol,
            {
                dataField: "actions",
                text: "Actions",
                align: 'right',
                formatter: actionURLFormatter,
                headerStyle: headerStyle
            }
        ];

        return columns;
    }

    const userTypeCol = role_id !== UserTypes.LAC && role_id !== UserTypes.DESI_TEACHER  && role_id !== UserTypes.ATTENDANCE_OFFICER ? [
        {
            dataField: "typeName",
            text: "User Type",
            sort: true,
            headerStyle: headerStyle,
        }
    ] : [] ;

    const schoolNameFormatter = (cell, row, rowIndex, formatExtraData) => {

        const viewChildURL = '/vschool/schools/' + row.school_id  ;

        return (
            <Fragment>
                <Link to={viewChildURL}>{row.school_name}</Link>
            </Fragment>
        );
    }


    const schoolCol = [ UserTypes.DESI_TEACHER,UserTypes.LAC, UserTypes.ATTENDANCE_OFFICER].includes(role_id) ? [
        {
            dataField: "school_name",
            text: "School",
            sort: true,
            formatter: schoolNameFormatter,
            headerStyle: headerStyle,
        },
    ] : [] ;

    const activeCol = LOGIN_USERS.includes(role_id) ? [
        {
            dataField: "active",
            text: "Active",
            formatter: statusFormatter,
            sort: true,
            align: 'center',
            sortType: activeSorter,
            headerStyle: headerStyle,
        },
    ] : [] ;

    const activeSorter = ( a,b )  =>
    {
        let aVal ;
        let bVal ;

        if ( LOGIN_USERS.includes( +a.original.type_id ))
        {
            aVal = a.original.password_change_required === null ? 1 : 0 ;
        }
        else
        {
            aVal = 3 ;
        }

        if ( LOGIN_USERS.includes( +b.original.type_id ))
        {
            bVal = b.original.password_change_required === null ? 1 : 0 ;
        }
        else
        {
            bVal = 3 ;
        }

        if (aVal < bVal) {
            return -1;
        }
        if (aVal > bVal) {
            return 1;
        }
        return 0;
    }

    const getTeacherColumns = () =>
    {
        const columns = [
            {
                dataField: "full_Name",
                text: "Name",
                sort: true,
                headerStyle: headerStyle,
                formatter: plainFormatter
            },
            {
                dataField: "surname",
                text: "Surname",
            },
            {
                dataField: "firstname",
                text: "Firstname",
            },
            ...schoolCol,
            ...userTypeCol,
            {
                dataField: "username",
                text: "User Name",
                sort: true,
                headerStyle: headerStyle,
            },
            {
                dataField: "email",
                text: "Email",
                headerStyle: headerStyle,
            },
            {
                dataField: "telNo",
                text: "Phone",
                headerStyle: headerStyle,
            },
            ...activeCol,
            {
                dataField: "actions",
                text: "Actions",
                align: 'right',
                formatter: actionURLFormatter,
                headerStyle: headerStyle
            }
        ];

        return columns;
    }

    let translations ;

    switch ( role_id )
    {
        case UserTypes.LAC:
            translations = xlateBootstrapTableColumns(getPupilColumns());
            break ;
        case UserTypes.DESI_TEACHER:
            translations = xlateBootstrapTableColumns(getTeacherColumns());
            break ;
        default:
            translations = xlateBootstrapTableColumns(getTeacherColumns());
            break ;
    }

    const columns = React.useMemo(() => translations, [data, role_id]);

    const initialState = { hiddenColumns: ['surname', 'firstname'] };

    const tableContent = () =>
    {
        return <PassportTable data={data} columns={columns} pagination={defaultPaginationOptions} userInitialState={initialState}/>

    }

    return loading === true ? <SpinnerDiv/> : tableContent();
};

export default TableUsers;
